/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPointRouteParams } from '@jira/platform__entry-points-plugin-types/src/types.tsx';
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import StakeholderGroupsPageQuery$parameters, {
	type StakeholderGroupsPageQuery,
} from './ui/__generated__/StakeholderGroupsPageQuery.graphql';

type CommunicationsStakeholderGroupsEntrypointComponent = EntryPointComponent<
	{
		StakeholderGroupsPageQuery: StakeholderGroupsPageQuery;
	},
	{},
	{},
	{}
>;

export const communicationsStakeholderGroupsEntrypoint: EntryPoint<
	CommunicationsStakeholderGroupsEntrypointComponent,
	EntryPointRouteParams
> = createEntryPoint({
	root: JSResourceForInteraction<CommunicationsStakeholderGroupsEntrypointComponent>(
		/* webpackChunkName: "async-communications-stakeholder-groups-entrypoint" */ './ui/StakeholderGroupsPage.tsx',
	),
	getPreloadProps: ({ tenantContext }) => {
		return {
			queries: {
				StakeholderGroupsPageQuery: {
					parameters: StakeholderGroupsPageQuery$parameters,
					variables: {
						first: 30,
						cloudId: tenantContext.cloudId,
					},
					options: {
						fetchPolicy: 'store-and-network' as const,
					},
				},
			},
		};
	},
});
